/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAuthInfo
 */
export interface UserAuthInfo {
    /**
     * 
     * @type {string}
     * @memberof UserAuthInfo
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthInfo
     */
    avatarUrl: string;
}

export function UserAuthInfoFromJSON(json: any): UserAuthInfo {
    return UserAuthInfoFromJSONTyped(json, false);
}

export function UserAuthInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAuthInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'login': json['login'],
        'name': json['name'],
        'email': json['email'],
        'avatarUrl': json['avatarUrl'],
    };
}

export function UserAuthInfoToJSON(value?: UserAuthInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'login': value.login,
        'name': value.name,
        'email': value.email,
        'avatarUrl': value.avatarUrl,
    };
}

